import { render, staticRenderFns } from "./radio-button-group.vue?vue&type=template&id=5509959e&scoped=true&"
import script from "./radio-button-group.vue?vue&type=script&lang=js&"
export * from "./radio-button-group.vue?vue&type=script&lang=js&"
import style0 from "./radio-button-group.vue?vue&type=style&index=0&id=5509959e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509959e",
  null
  
)

export default component.exports